/* eslint-disable @typescript-eslint/no-explicit-any -- Supabase JSON/RPC + composer boundary; see mem://preferences/lint-debt.md */
import { supabase } from "@/integrations/supabase/client";
import type { TablesInsert } from "@/integrations/supabase/types";
import type { ContentSource } from "../types";
import { getFriendlyMessage, normalizeText } from "../_shared";

export const createSource = async (workspaceId: string, values: { title: string; bucket: TablesInsert<"content_sources">["bucket"]; sourceType: string; originLabel?: string; summary?: string; notes?: string }) => {
  const payload: TablesInsert<"content_sources"> = {
    workspace_id: workspaceId,
    title: normalizeText(values.title),
    bucket: values.bucket,
    source_type: normalizeText(values.sourceType),
    origin_label: values.originLabel?.trim() ?? null,
  };
  const { data, error } = await supabase.from("content_sources").insert(payload).select("id").single();
  if (error) throw new Error(getFriendlyMessage(error, "Failed to create the source item"));

  const summary = values.summary?.trim() ?? null;
  const notes = values.notes?.trim() ?? null;
  if (summary || notes) {
    const { error: textError } = await (supabase as any).rpc("set_content_source_text", {
      _source_id: (data as { id: string }).id,
      _summary: summary,
      _notes: notes,
    });
    if (textError) throw new Error(getFriendlyMessage(textError, "Failed to save the source text"));
  }

  const { data: full, error: fetchError } = await supabase
    .from("content_sources")
    .select("id, workspace_id, title, bucket, source_type, origin_label, status, key_version, body_encrypted, body_preview, summary:summary_preview, notes:notes_preview, summary_key_version, notes_key_version, metadata, created_at, updated_at")
    .eq("id", (data as { id: string }).id)
    .single();
  if (fetchError) throw new Error(getFriendlyMessage(fetchError, "Failed to load the new source item"));
  return full as unknown as ContentSource;
};
